import React, { useEffect, useState, Dispatch, SetStateAction, useCallback, useRef } from 'react';
import { Card, Button, Table } from 'antd';
import PageContainer from '../../../../CSIComponents/PageContainer';
import type { ColumnsType } from 'antd/es/table';
import { LocalPersistence, ApiCallsFactory } from '@factories/index';
import { PropertySearch } from '@factories/propertySearchs';
import Grid from '@material-ui/core/Grid';
import ImputComponent from "../../../../InputComponent"
import SearchDebounceBar from '../../../../SearchDebounce';
import SearchIcon from '@material-ui/icons/Search';

interface checkoutChargeType {
    description: string | null,
    chargetype: string | null,
    currency: string | null,
    charge: string | null,
    policytype: string | null
}

interface detailType {
    label?: string,
    span?: number,
    value?: string | null
}
interface propsTypes {
    isEditable: ()=>void,
    cancelEditable: ()=>void,
    setOperationType: Dispatch<SetStateAction<string>>,
    detailData: {
        policies:{
            checkoutcharge:Array<checkoutChargeType>
        }
    },
    supplier: string,
    propertyid: string,
    getPoliciesData: () => {},
    setPoliciesData: Dispatch<SetStateAction<string | null>>,
}

interface DataType {
    key: React.Key;
    name: string;
    age: number;
    address: string;
    description: string;
  }

const CheckOutChargeDetail = (props: propsTypes) => {
    const [detailData, setDetailData] = useState<Array<Array<detailType>>>([[]])
    const [paginationData, setPaginationData] = useState<number>(10)
    const [total] = useState(detailData.length);
    const [ready, setReady] = useState<boolean>(false)
    const [searchs, setSearch] = useState<string[]>([]);
    const initialRender = useRef(true);
    const [data, setData] = useState<Array<Array<detailType>>>([[]]);
    const columns: ColumnsType<DataType> | any = [
        {
          title: '',
          key: 'index',
          // @ts-expect-error
          render: (text: string, record: [], index: number) => Number(record?.key) ? Number(record?.key) + 1 : index += 1,
          width: '40px'
        },
        {
            title: 'Policiy Type', 
            dataIndex: 'policytype', 
            key: 'policytype',
        },
        { 
          title: 'Charge Type', 
          dataIndex: 'chargetype', 
          key: 'chargetype',
          onCell: (record: { amenityType: string }, index: number) => {
            return {
                onClick: (ev: any) => {
                  // edit mode
                  // setEditData(record)
                  // setVisibleEdition(true)
                }, 
            };
          },
          // @ts-ignore ignoring as there are data issues
          sorter: (a, b) => sortHelper(a, b, 'amenityType'),
          showSorterTooltip: false,
          },
        {
          title: 'Charge', 
          dataIndex: 'charge', 
          key: 'charge',
        },
        {
          title: 'Description', 
          dataIndex: 'description', 
          key: 'description',
        },
      ];

      const onChangeSearch = (term: string) => {
        setSearchTerm(term)
        onDebounce(term)
    }
    const {
        searchTerm, setSearchTerm, searchTermDebounced, onDebounce
    } = SearchDebounceBar()

    const recentlySearchs = () => {
        return searchs.map((search, index) => {
            return (
                <span key={index} onClick={() => recoverSearch(search)}>
                    &nbsp;{search}{searchs.length - 1 === index ? '.' : ','}
                </span>
            )
        })
    }
    const recoverSearch = (search: string) => {
        setSearchTerm(search)
        filterData(search)
        onDebounce(search)
    }

    const saveNewSearch = (term: string) => {
        const stackSearchs = new PropertySearch(searchs)
        setSearch(stackSearchs.add(term))
    }
    const afterDebounce = (term: string) => {
        if (term) {
            saveNewSearch(term)
        }
        filterData(term)
    }
    const filterData = async (query: string) => {
        const filterData = data.filter((item: any) => {
            const newFilterData: any = {}
            columns.forEach((col: any) => {
                newFilterData[col['dataIndex']] = (item[col.dataIndex] == null || item[col.dataIndex] == undefined) ? '' : JSON.stringify(item[col.dataIndex]).toLowerCase();
            })
            return JSON.stringify(Object.values(newFilterData)).indexOf(query.toLowerCase()) > -1;
        })
        setDetailData(filterData);
    }
    
    const getData = useCallback(async () => {
        try {
            const get_session = new LocalPersistence('session')
            const session: any = await get_session.getSessionPersistence();
            const getService = new ApiCallsFactory(`/property/policies?supplier=${session.supplier}&propertyid=${session.propertyId}`,session.token)
            const response = await getService.getData()
            // @ts-expect-error
            const { property: { policies: { checkoutcharge } }} = response
            setDetailData(checkoutcharge)
            setData(checkoutcharge)
            return setReady(true)
        } catch (error) {
            setReady(true)
            return error
        }
        // 
    }, [])

    useEffect(() => {
        getData()
    }, [getData])

    //   search functionality
    useEffect(() => {
        if (initialRender.current) {
            initialRender.current = false;
        } else {
            afterDebounce(searchTermDebounced);
        }
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [searchTermDebounced])

    return (
        <PageContainer>
            {ready && <Card 
                style={{ marginTop: -15 }} 
                title="Check Out Charge" 
                headStyle={{ fontWeight: 600, fontSize: 14, color: '#333', paddingTop: '8px' }}
                extra={
                    <Button 
                      type="primary" 
                      className="db-edit-btn" 
                      onClick={() => { 
                        // @ts-expect-error  
                        props.setPoliciesData([{
                            row: {
                                charge: "",
                                chargetype: "",
                                currency: "",
                                description: "",
                                policytype: ""
                            },
                            data: detailData,
                            action: 'add'
                        }])
                        props.isEditable(); 
                        props.setOperationType('edit') 
                      }}>Add</Button>}
                >
                <div style={{ padding: "0 20px" }}>
                    <Grid item xs={4} className="pb-0 px-0 my-0">
                        <ImputComponent
                            className = 'SearchBar'
                            label='Search'
                            labelShrink = {true}
                            value={searchTerm}
                            onChange={onChangeSearch}
                            placeholder='Search Check Out Charge'
                            endAdornment={<SearchIcon style={{color: '#9a9a9a'}}/>}
                        />
                        <div className="recentlySearchs">
                            <p>{'Recently searched'}: {recentlySearchs()}</p>
                        </div>
                    </Grid>
                    <Grid className="pb-0 px-0 my-0 pt-2">
                    <Table
                        columns={columns}
                        /* locale={{ emptyText: (
                            <>
                            <img src={noData} alt='no data' style={{ marginTop: 56, marginBottom: 24 }} />
                            <div style={{ fontSize: 16, color: '#333333' }}>No amenitites have been created. <br/> Please add amenities to the Amenities section.</div>
                            <Button className="db-add-btn" style={{ width: 150, height: 40, marginTop: 33, marginBottom: 90 }} onClick={() => true}> Edit </Button>
                            </>
                        )
                        }} */
                        dataSource={detailData}
                        pagination={{
                            pageSizeOptions: ['10', '20', '50', '100'],
                            showSizeChanger: true,
                            showTotal: (total, range) => `Total ${total} items, current ${range[0]}-${range[1]}`,
                            defaultPageSize: paginationData,
                            defaultCurrent: 1,
                            // onShowSizeChange: (current, size: number) => paginationSize('pagination', { 'room_amenities': size }),
                            size: "small",
                            total
                        }}
                        onRow={(record, rowIndex) => {
                            return {
                                onClick: () => {
                                    // @ts-expect-error
                                    props.setPoliciesData([{ data: detailData, row: { rowIndex, ...record }, action: 'edit'}])
                                    props.isEditable(); props.setOperationType('edit')
                                },
                            };
                        }}
                    />
                    </Grid>
                </div>
            </Card>}
        </PageContainer>
    )
}

export default CheckOutChargeDetail;


